import * as actionTypes from './actionTypes';
import { passwordService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidateAccess } from '@app/src/common/session';

const forgotPasswordRequest = () => ({
  type: actionTypes.FORGOT_PASSWORD_REQUEST
});

const forgotPasswordFailure = () => ({
  type: actionTypes.FORGOT_PASSWORD_FAILURE
});

const forgotPasswordSuccess = (data) => ({
  type: actionTypes.FORGOT_PASSWORD_SUCCESS,
  data
});

const resetPasswordRequest = () => ({
	type: actionTypes.RESET_PASSWORD_REQUEST
});
  
const resetPasswordFailure = () => ({
	type: actionTypes.RESET_PASSWORD_FAILURE
});
  
const resetPasswordSuccess = (data) => ({
	type: actionTypes.RESET_PASSWORD_SUCCESS,
	data
});

export const fetchForgotPassword = (json, token: string) => {
  return async dispatch => {
    dispatch(forgotPasswordRequest());
    await dispatch(fetchValidateAccess());
    try {
      json.token = token;
      const data = await passwordService.postForgot(json);
      if (data.error && data.data && data.data.length === 0) {
        dispatch(actionsModalError.openModalError(data.message));
        dispatch(forgotPasswordFailure());
      } else {
        dispatch(forgotPasswordSuccess(data.data[0]));
        dispatch(actionsModalError.openModalError(data.message));
      }
    } catch(error) {
      console.log(error, 'error')
      dispatch(actionsModalError.openModalError());
      dispatch(forgotPasswordFailure());
    }
  }
};

export const fetchResetPassword = (json) => {
    return async dispatch => {
      dispatch(resetPasswordRequest());
      await dispatch(fetchValidateAccess());
      try {
        const data = await passwordService.postReset(json);
        dispatch(actionsModalError.openModalError(data.message));
        if (data.error) {
          dispatch(resetPasswordFailure());
        } else {
          dispatch(resetPasswordSuccess(data.data[0]));
          if (data && data.data && data.data.length > 0) {
            setTimeout(() => {
              window.location.href = `${process.env.PATH_ROOT}/inicia-tu-sesion`;
            }, 500);
          }
        }
      } catch(error) {
        console.log(error, 'error')
        dispatch(actionsModalError.openModalError());
        dispatch(resetPasswordFailure());
      }
    }
  };
  
